import React, { useEffect } from 'react';
import './App.scss';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import Landing from './components/pages/landing/LandingPage';
import UpNext from './components/pages/upNext/UpNext';
import { Favorites } from './components/pages/favorites/Favorites';
import NavBar from './components/parts/topNavigation/NavBar';
import MediaInfoPage from './components/pages/mediaInfo/MediaInfoPage';
import { trackPageView } from './utils/analytics';
import { HOME_DESCRIPTION, HOME_TITLE, updateSeo } from './utils/seo';

function Analytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const privatePage = pathname === '/favorites' || pathname === '/up-next';
    updateSeo({
      title: privatePage ? `${pathname === '/favorites' ? 'Favorite Shows' : 'Upcoming Episodes'} | Showladex` : HOME_TITLE,
      description: HOME_DESCRIPTION,
      path: pathname,
      noindex: privatePage,
    });
    trackPageView(`${window.location.origin}${pathname}${search}`);
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Analytics />
        <NavBar />
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route exact path="/show/:id" component={MediaInfoPage} />
          <Route exact path="/movie/:id" component={MediaInfoPage} />
          <Route exact path="/up-next" component={UpNext} />
          <Route exact path="/favorites" component={Favorites} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
